// import { useState, useEffect } from "react";
// import axios from "axios";
// import "./Gallery.css";

// export default function Gallery() {
//     const [gallery, setGallery] = useState([]);
//     const [galleryPhotos, setGalleryPhotos] = useState({});
//     const [editId, setEditId] = useState(null);
//     const [activeTab, setActiveTab] = useState("all");
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [selectedItemPhotos, setSelectedItemPhotos] = useState([]);
//     const [showCreateModal, setShowCreateModal] = useState(false);
//     const [showViewModal, setShowViewModal] = useState(false);
//     const [showAddPhotosModal, setShowAddPhotosModal] = useState(false);
//     const [selectedGalleryForPhotos, setSelectedGalleryForPhotos] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isUploadingPhotos, setIsUploadingPhotos] = useState(false);
    
//     // All form fields
//     const [formData, setFormData] = useState({
//         category: "",
//         type: "photo",
//         title: "",
//         desc: "",
//         count: 1,
//         image_file: null,
//         photos_files: []
//     });

//     // For add photos modal
//     const [addPhotosData, setAddPhotosData] = useState({
//         photos_files: [],
//         photoPreviews: []
//     });

//     const API_BASE = process.env.REACT_APP_API_URL;
//     const [errors, setErrors] = useState({});
//     const [photoPreviews, setPhotoPreviews] = useState([]);
//     const [imagePreview, setImagePreview] = useState("");

//     useEffect(() => {
//         fetchGallery();
//     }, []);

//     const fetchGallery = async () => {
//         try {
//             setLoading(true);
//             const res = await axios.get(`${API_BASE}Gallery.php`);
            
//             console.log("Gallery API Response:", res.data);
            
//             if (res.data.status === "success") {
//                 const galleryData = res.data.data || [];
//                 setGallery(galleryData);
                
//                 // Fetch photos for all gallery items
//                 await fetchAllGalleryPhotos(galleryData);
//             } else {
//                 setGallery([]);
//                 setGalleryPhotos({});
//             }
//         } catch (err) {
//             console.error("Failed to load gallery", err);
//             setGallery([]);
//             setGalleryPhotos({});
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchAllGalleryPhotos = async (galleryItems) => {
//         const photosMap = {};
        
//         // Fetch first 3 photos for each gallery item
//         for (const item of galleryItems) {
//             try {
//                 // Get first 3 photos for preview
//                 const res = await axios.get(`${API_BASE}Gallery.php?id=${item.id}&limit=3`);
//                 if (res.data.status === "success") {
//                     photosMap[item.id] = res.data.data.photos || [];
//                 } else {
//                     photosMap[item.id] = [];
//                 }
//             } catch (err) {
//                 console.error(`Failed to load photos for gallery ${item.id}`, err);
//                 photosMap[item.id] = [];
//             }
//         }
        
//         setGalleryPhotos(photosMap);
//     };

//     const fetchGalleryPhotos = async (galleryId, page = 1, limit = 100) => {
//         try {
//             const res = await axios.get(`${API_BASE}Gallery.php?id=${galleryId}&page=${page}&limit=${limit}`);
//             if (res.data.status === "success") {
//                 const photos = res.data.data.photos || [];
//                 setGalleryPhotos(prev => ({
//                     ...prev,
//                     [galleryId]: photos
//                 }));
//                 return photos;
//             }
//             return [];
//         } catch (err) {
//             console.error(`Failed to load photos for gallery ${galleryId}`, err);
//             return [];
//         }
//     };

//     // Gallery types
//     const galleryTypes = [
//         { value: "photo", label: "📷 Photos" },
//         { value: "video", label: "🎥 Videos" },
//         { value: "press", label: "📰 Press Coverage" }
//     ];

//     // Category options
//     const categoryOptions = [
//         "All Photo",
//         "Disaster Relief Fund",
//         "Animal Welfare",
//         "Environmental Protection",
//         "Senior Citizen Care",
//         "Youth Empowerment",
//         "Cultural Festivals",
//         "Community Service",
//         "Health Camps",
//         "Educational Programs"
//     ];

//     const validateField = (name, value) => {
//         switch (name) {
//             case "category":
//                 if (!value) return "Category is required";
//                 else return "";
//             case "title":
//                 if (!value) return "Title is required";
//                 else if (value.length < 3) return "Title must be at least 3 characters";
//                 else return "";
//             case "desc":
//                 if (!value) return "Description is required";
//                 else if (value.length < 10) return "Description must be at least 10 characters";
//                 else return "";
//             case "count":
//                 if (!value || value < 1) return "Count must be at least 1";
//                 else return "";
//             default:
//                 return "";
//         }
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });

//         const errorMsg = validateField(name, value);
//         setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMsg }));
//     };

//     // Handle main image file upload
//     const handleImageFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setFormData(prev => ({ ...prev, image_file: file }));
            
//             // Create preview
//             const reader = new FileReader();
//             reader.onload = (e) => {
//                 setImagePreview(e.target.result);
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     // Handle multiple photo files upload (for main form)
//     const handlePhotosFilesChange = (e) => {
//         const files = Array.from(e.target.files);
        
//         if (files.length > 0) {
//             const newFiles = [...formData.photos_files, ...files];
//             setFormData(prev => ({ 
//                 ...prev, 
//                 photos_files: newFiles
//             }));
            
//             // Create previews
//             const newPreviews = [];
//             files.forEach(file => {
//                 const reader = new FileReader();
//                 reader.onload = (e) => {
//                     newPreviews.push(e.target.result);
//                     // When all files are read, update state
//                     if (newPreviews.length === files.length) {
//                         setPhotoPreviews(prev => [...prev, ...newPreviews]);
//                     }
//                 };
//                 reader.readAsDataURL(file);
//             });
//         }
//     };

//     // Remove a photo from the list (for new uploads in main form)
//     const removePhoto = (index) => {
//         setFormData(prev => ({
//             ...prev,
//             photos_files: prev.photos_files.filter((_, i) => i !== index)
//         }));
//         setPhotoPreviews(prev => prev.filter((_, i) => i !== index));
//     };

//     // Remove an existing photo from gallery_photos table
//     const removeExistingPhoto = async (photoId, galleryId) => {
//         if (!window.confirm("Are you sure you want to delete this photo?")) return;
        
//         try {
//             // We need a separate endpoint for deleting individual photos
//             // Since your backend doesn't have it, we'll handle it differently
//             alert("Note: Individual photo deletion requires a separate API endpoint. Please implement a delete photo endpoint in your backend.");
            
//             // For now, we'll just remove from state
//             setGalleryPhotos(prev => ({
//                 ...prev,
//                 [galleryId]: (prev[galleryId] || []).filter(photo => photo.id !== photoId)
//             }));
            
//             // Update selected item photos if viewing
//             if (selectedItem && selectedItem.id === galleryId) {
//                 setSelectedItemPhotos(prev => prev.filter(photo => photo.id !== photoId));
//             }
            
//         } catch (err) {
//             console.error("Delete photo failed", err);
//             alert("Delete failed: " + (err.response?.data?.message || err.message));
//         }
//     };

//     // Open add photos modal
//     const openAddPhotosModal = (galleryItem) => {
//         setSelectedGalleryForPhotos(galleryItem);
//         setAddPhotosData({
//             photos_files: [],
//             photoPreviews: []
//         });
//         setShowAddPhotosModal(true);
//     };

//     // Handle photo file selection for add photos modal
//     const handleAddPhotosFileChange = (e) => {
//         const files = Array.from(e.target.files);
        
//         if (files.length > 0) {
//             const newPhotoPreviews = [];
//             const newPhotosFiles = [...addPhotosData.photos_files, ...files];
            
//             files.forEach((file) => {
//                 const reader = new FileReader();
//                 reader.onload = (e) => {
//                     newPhotoPreviews.push(e.target.result);
                    
//                     // Update state when all files are processed
//                     setAddPhotosData(prev => ({
//                         photos_files: newPhotosFiles,
//                         photoPreviews: [...prev.photoPreviews, ...newPhotoPreviews]
//                     }));
//                 };
//                 reader.readAsDataURL(file);
//             });
//         }
//     };

//     // Remove photo from add photos modal
//     const removeAddPhoto = (index) => {
//         setAddPhotosData(prev => ({
//             ...prev,
//             photos_files: prev.photos_files.filter((_, i) => i !== index),
//             photoPreviews: prev.photoPreviews.filter((_, i) => i !== index)
//         }));
//     };

//     // Upload additional photos
//     const uploadAdditionalPhotos = async () => {
//         if (!selectedGalleryForPhotos || addPhotosData.photos_files.length === 0) {
//             alert("Please select photos to upload");
//             return;
//         }

//         try {
//             setIsUploadingPhotos(true);
//             const fd = new FormData();
            
//             // Use PUT method with X-HTTP-Method-Override header for adding photos
//             fd.append("id", selectedGalleryForPhotos.id);
            
//             // Add all photo files
//             addPhotosData.photos_files.forEach((file, index) => {
//                 fd.append(`photos[${index}]`, file);
//             });

//             console.log("Uploading photos to gallery:", selectedGalleryForPhotos.id);
            
//             // Use POST with X-HTTP-Method-Override for PUT
//             const response = await axios.post(`${API_BASE}Gallery.php`, fd, {
//                 headers: { 
//                     'Content-Type': 'multipart/form-data',
//                     'X-HTTP-Method-Override': 'PUT'
//                 }
//             });

//             console.log("Upload photos response:", response.data);

//             if (response.data.status === "success") {
//                 alert(`Photos added successfully!`);
                
//                 // Refresh photos for this gallery
//                 await fetchGalleryPhotos(selectedGalleryForPhotos.id);
                
//                 // Refresh main gallery to update count
//                 fetchGallery();
                
//                 // Close modal and reset
//                 closeAddPhotosModal();
//             } else {
//                 alert(response.data.message || "Failed to upload photos");
//             }
//         } catch (err) {
//             console.error("Upload photos failed", err);
//             alert(err.response?.data?.message || "Something went wrong while uploading photos");
//         } finally {
//             setIsUploadingPhotos(false);
//         }
//     };

//     // Close add photos modal
//     const closeAddPhotosModal = () => {
//         setShowAddPhotosModal(false);
//         setSelectedGalleryForPhotos(null);
//         setAddPhotosData({
//             photos_files: [],
//             photoPreviews: []
//         });
//     };

//     const openCreateModal = () => {
//         setFormData({
//             category: "",
//             type: "photo",
//             title: "",
//             desc: "",
//             count: 1,
//             image_file: null,
//             photos_files: []
//         });
//         setPhotoPreviews([]);
//         setImagePreview("");
//         setEditId(null);
//         setErrors({});
//         setShowCreateModal(true);
//     };

//     const openEditModal = async (item) => {
//         try {
//             // Fetch the gallery item with its photos
//             const res = await axios.get(`${API_BASE}Gallery.php?id=${item.id}`);
            
//             if (res.data.status === "success") {
//                 const galleryData = res.data.data;
//                 const photos = galleryData.photos || [];
                
//                 setFormData({
//                     category: galleryData.category || "",
//                     type: galleryData.type || "photo",
//                     title: galleryData.title || "",
//                     desc: galleryData.desc || "",
//                     count: galleryData.count || 1,
//                     image_file: null,
//                     photos_files: []
//                 });
                
//                 // Set image preview from existing image
//                 if (galleryData.image) {
//                     setImagePreview(galleryData.image);
//                 }
                
//                 // Set existing photos for reference
//                 setPhotoPreviews(photos.map(p => p.photo));
                
//                 setEditId(galleryData.id);
//                 setErrors({});
//                 setShowCreateModal(true);
//             }
//         } catch (err) {
//             console.error("Edit load failed", err);
//             alert("Failed to load gallery item");
//         }
//     };

//     const closeModal = () => {
//         setShowCreateModal(false);
//         setEditId(null);
//         setFormData({
//             category: "",
//             type: "photo",
//             title: "",
//             desc: "",
//             count: 1,
//             image_file: null,
//             photos_files: []
//         });
//         setPhotoPreviews([]);
//         setImagePreview("");
//         setErrors({});
//     };

//     const handleSubmit = async () => {
//         if (isSubmitting) return;
        
//         const requiredFields = ['category', 'title', 'desc', 'count'];
//         const newErrors = {};

//         requiredFields.forEach(field => {
//             const error = validateField(field, formData[field]);
//             if (error) newErrors[field] = error;
//         });

//         // Validate that image file is provided
//         if (!formData.image_file && !editId) {
//             newErrors.image = "Main image is required";
//         }

//         if (Object.keys(newErrors).length > 0) {
//             setErrors(newErrors);
//             alert("Please fill all required fields correctly!");
//             return;
//         }

//         try {
//             setIsSubmitting(true);
//             const fd = new FormData();

//             console.log("Submitting form data:", {
//                 category: formData.category,
//                 type: formData.type,
//                 title: formData.title,
//                 desc: formData.desc,
//                 count: formData.count,
//                 hasImageFile: !!formData.image_file,
//                 editId
//             });

//             // Add basic fields
//             fd.append("category", formData.category);
//             fd.append("type", formData.type);
//             fd.append("title", formData.title);
//             fd.append("desc", formData.desc);
//             fd.append("count", formData.count);

//             // Handle main image
//             if (formData.image_file) {
//                 console.log("Adding image file:", formData.image_file.name);
//                 fd.append("image", formData.image_file);
//             }

//             // Handle additional photos (only for new gallery items)
//             if (!editId && formData.photos_files.length > 0) {
//                 console.log("Adding photos files:", formData.photos_files.length);
//                 formData.photos_files.forEach((file, index) => {
//                     fd.append(`photos[${index}]`, file);
//                 });
//             }

//             let endpoint = `${API_BASE}Gallery.php`;
            
//             // If editing, use PUT method override
//             if (editId) {
//                 fd.append("id", editId);
//             }

//             console.log("Sending to endpoint:", endpoint);
            
//             const response = await axios.post(endpoint, fd, {
//                 headers: { 
//                     'Content-Type': 'multipart/form-data',
//                     ...(editId && { 'X-HTTP-Method-Override': 'PUT' })
//                 }
//             });

//             console.log("Server response:", response.data);

//             if (response.data.status === "success") {
//                 let message = editId ? "Gallery item updated successfully!" : "Gallery item added successfully!";
                
//                 if (!editId && response.data.gallery_id) {
//                     message += ` (ID: ${response.data.gallery_id})`;
//                 }
                
//                 alert(message);
                
//                 // Clear form and close modal first
//                 closeModal();
                
//                 // Then refresh gallery data
//                 fetchGallery();
//             } else {
//                 alert(response.data.message || "Operation failed");
//             }
//         } catch (err) {
//             console.error("Save failed", err);
//             alert(err.response?.data?.message || "Something went wrong while saving");
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (!window.confirm("Are you sure you want to delete this gallery item and all its photos?")) return;

//         try {
//             console.log("Deleting gallery item ID:", id);

//             const response = await axios.delete(`${API_BASE}Gallery.php`, {
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 data: { id },
//             });

//             console.log("Delete response:", response.data);

//             if (response.data.status === "success") {
//                 alert("Gallery item deleted successfully!");
//                 fetchGallery();
//             } else {
//                 alert(response.data.message || "Delete failed");
//             }

//         } catch (err) {
//             console.error("Delete failed", err);
//             alert("Failed to delete gallery item. Please try again.");
//         }
//     };

//     const handleViewDetails = async (item) => {
//         setSelectedItem(item);
        
//         // Fetch photos for this gallery item with higher limit
//         const photos = await fetchGalleryPhotos(item.id, 1, 50);
//         setSelectedItemPhotos(photos);
        
//         setShowViewModal(true);
//     };

//     const closeViewModal = () => {
//         setShowViewModal(false);
//         setSelectedItem(null);
//         setSelectedItemPhotos([]);
//     };

//     // Filter function
//     const filteredGallery = Array.isArray(gallery) ? gallery.filter(item => {
//         if (!item) return false;
        
//         const matchesType = activeTab === "all" || item.type === activeTab;

//         const title = item.title || "";
//         const category = item.category || "";
//         const desc = item.desc || "";

//         const matchesSearch =
//             title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             category.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             desc.toLowerCase().includes(searchTerm.toLowerCase());

//         return matchesType && matchesSearch;
//     }) : [];

//     // Calculate stats safely
//     const stats = {
//         photos: Array.isArray(gallery) ? gallery.filter(item => item && item.type === "photo").length : 0,
//         videos: Array.isArray(gallery) ? gallery.filter(item => item && item.type === "video").length : 0,
//         press: Array.isArray(gallery) ? gallery.filter(item => item && item.type === "press").length : 0,
//         totalItems: Array.isArray(gallery) ? gallery.length : 0,
//         totalPhotos: Object.values(galleryPhotos).reduce((total, photos) => total + (photos?.length || 0), 0)
//     };

//     return (
//         <div className="gallery-admin">
//             {/* Header with Create Button */}
//             <div className="gallery-header">
//                 <div className="header-top">
//                     <h2><span>🖼️</span> Media Gallery Management</h2>
//                     <button className="btn-create" onClick={openCreateModal} disabled={loading}>
//                         <span>+</span> Add New Gallery Item
//                     </button>
//                 </div>
//                 <p className="subtitle">Manage photos, videos, and press coverage for your media gallery</p>

//                 {/* Debug info */}
//                 <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
//                     Total items in gallery: {gallery.length} | Showing: {filteredGallery.length}
//                 </div>

//                 {/* Tabs */}
//                 <div className="gallery-tabs">
//                     <button
//                         className={`tab-btn ${activeTab === "all" ? "active" : ""}`}
//                         onClick={() => setActiveTab("all")}
//                         disabled={loading}
//                     >
//                         📁 All Media
//                     </button>
//                     {galleryTypes.map(type => (
//                         <button
//                             key={type.value}
//                             className={`tab-btn ${activeTab === type.value ? "active" : ""}`}
//                             onClick={() => setActiveTab(type.value)}
//                             disabled={loading}
//                         >
//                             {type.label}
//                         </button>
//                     ))}
//                 </div>

//                 {/* Search Bar */}
//                 <div className="search-section">
//                     <div className="search-bar">
//                         <input
//                             type="text"
//                             placeholder="Search gallery by title, category, or description..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             disabled={loading}
//                         />
//                     </div>
//                 </div>
//             </div>

//             {/* Gallery Stats */}
//             <div className="gallery-stats">
//                 <div className="stat-card">
//                     <div className="stat-icon">📁</div>
//                     <div className="stat-content">
//                         <h3>{stats.totalItems}</h3>
//                         <p>Total Albums</p>
//                     </div>
//                 </div>
//                 <div className="stat-card">
//                     <div className="stat-icon">📷</div>
//                     <div className="stat-content">
//                         <h3>{stats.photos}</h3>
//                         <p>Photo Albums</p>
//                     </div>
//                 </div>
//                 <div className="stat-card">
//                     <div className="stat-icon">🎥</div>
//                     <div className="stat-content">
//                         <h3>{stats.videos}</h3>
//                         <p>Video Albums</p>
//                     </div>
//                 </div>
//                 <div className="stat-card">
//                     <div className="stat-icon">📰</div>
//                     <div className="stat-content">
//                         <h3>{stats.press}</h3>
//                         <p>Press Albums</p>
//                     </div>
//                 </div>
//                 <div className="stat-card">
//                     <div className="stat-icon">🖼️</div>
//                     <div className="stat-content">
//                         <h3>{stats.totalPhotos}</h3>
//                         <p>Total Photos</p>
//                     </div>
//                 </div>
//             </div>

//             {/* Gallery Grid */}
//             <div className="gallery-list-container">
//                 <div className="list-header">
//                     <h3>
//                         {activeTab === "all" ? "All Media" :
//                             activeTab === "photo" ? "Photo Gallery" :
//                                 activeTab === "video" ? "Video Gallery" : "Press Coverage"}
//                         ({filteredGallery.length})
//                     </h3>
//                     <div className="table-actions">
//                         <span className="results-count">
//                             Showing {filteredGallery.length} of {stats.totalItems} items
//                         </span>
//                     </div>
//                 </div>

//                 {loading ? (
//                     <div className="empty-state">
//                         <div className="loading-spinner"></div>
//                         <p>Loading gallery items...</p>
//                     </div>
//                 ) : filteredGallery.length === 0 ? (
//                     <div className="empty-state">
//                         <div className="empty-icon">🖼️</div>
//                         <p>No gallery items found</p>
//                         <p className="empty-subtext">
//                             {activeTab === "all" ? "Try adding some media items" :
//                                 `Try adding some ${activeTab} items or check other tabs`}
//                         </p>
//                         <button className="btn-create-empty" onClick={openCreateModal} disabled={loading}>
//                             Add Your First Gallery Item
//                         </button>
//                     </div>
//                 ) : (
//                     <div className="gallery-grid">
//                         {filteredGallery.map(item => {
//                             const itemPhotos = galleryPhotos[item.id] || [];
//                             const totalPhotos = itemPhotos.length;
                            
//                             return (
//                                 <div key={item.id} className="gallery-card">
//                                     <div
//                                         className="gallery-card-image"
//                                         style={{
//                                             backgroundImage: `url(${item.image || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNmMGYwZjAiLz48dGV4dCB4PSI1MCIgeT0iNTAiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iIGZpbGw9IiM5OTk5OTkiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg=='})`,
//                                             backgroundSize: 'cover',
//                                             backgroundPosition: 'center'
//                                         }}
//                                     >
//                                         <span className={`gallery-tag type-${item.type || 'photo'}`}>
//                                             {item.type === "photo" ? "📷 Photo" :
//                                                 item.type === "video" ? "🎥 Video" : "📰 Press"}
//                                         </span>
//                                         <span className="gallery-count">
//                                             {totalPhotos > 0 ? `${totalPhotos} photos` : 'No photos'}
//                                         </span>
//                                     </div>

//                                     <div className="gallery-card-body">
//                                         <div className="gallery-category">{item.category || "Uncategorized"}</div>
//                                         <h3 className="gallery-title">{item.title || "Untitled"}</h3>
//                                         <p className="gallery-desc">{item.desc || "No description available"}</p>

//                                         <div className="gallery-card-info">
//                                             <span className="info-item">
//                                                 📊 Main Items: {item.count || 0}
//                                             </span>
//                                             <span className="info-item">
//                                                 🖼️ Additional Photos: {totalPhotos}
//                                             </span>
//                                         </div>

//                                         <div className="gallery-card-actions">
//                                             <button
//                                                 className="btn-view"
//                                                 onClick={() => handleViewDetails(item)}
//                                                 title="View Details"
//                                                 disabled={loading}
//                                             >
//                                                 👁️ View
//                                             </button>
//                                             <button
//                                                 className="btn-edit"
//                                                 onClick={() => openEditModal(item)}
//                                                 title="Edit Item"
//                                                 disabled={loading}
//                                             >
//                                                 ✏️ Edit
//                                             </button>
//                                             <button
//                                                 className="btn-add-photos"
//                                                 onClick={() => openAddPhotosModal(item)}
//                                                 title="Add More Photos"
//                                                 disabled={loading}
//                                             >
//                                                 ➕ Add Photos
//                                             </button>
//                                             <button
//                                                 className="btn-delete"
//                                                 onClick={() => handleDelete(item.id)}
//                                                 title="Delete Item"
//                                                 disabled={loading}
//                                             >
//                                                 🗑️ Delete
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 )}
//             </div>

//             {/* Create/Edit Gallery Item Modal */}
//             {showCreateModal && (
//                 <div className="modal-overlay">
//                     <div className="modal-container">
//                         <div className="modal-header">
//                             <h3>{editId ? "Edit Gallery Item" : "Add New Gallery Item"}</h3>
//                             <button className="close-btn" onClick={closeModal} disabled={isSubmitting}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="modal-form">
//                                 {/* Basic Info */}
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Gallery Type *</label>
//                                         <select
//                                             name="type"
//                                             value={formData.type}
//                                             onChange={handleChange}
//                                             disabled={isSubmitting}
//                                         >
//                                             {galleryTypes.map(type => (
//                                                 <option key={type.value} value={type.value}>
//                                                     {type.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     <div className="form-group">
//                                         <label>Category *</label>
//                                         <select
//                                             name="category"
//                                             value={formData.category}
//                                             onChange={handleChange}
//                                             className={errors.category ? "error" : ""}
//                                             disabled={isSubmitting}
//                                         >
//                                             <option value="">Select Category</option>
//                                             {categoryOptions.map(category => (
//                                                 <option key={category} value={category}>{category}</option>
//                                             ))}
//                                         </select>
//                                         {errors.category && <span className="error-text">{errors.category}</span>}
//                                     </div>
//                                 </div>

//                                 {/* Title and Count */}
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Title *</label>
//                                         <input
//                                             type="text"
//                                             name="title"
//                                             value={formData.title}
//                                             onChange={handleChange}
//                                             placeholder="Enter gallery title"
//                                             className={errors.title ? "error" : ""}
//                                             disabled={isSubmitting}
//                                         />
//                                         {errors.title && <span className="error-text">{errors.title}</span>}
//                                     </div>

//                                     <div className="form-group">
//                                         <label>Item Count *</label>
//                                         <input
//                                             type="number"
//                                             name="count"
//                                             value={formData.count}
//                                             onChange={handleChange}
//                                             min="1"
//                                             className={errors.count ? "error" : ""}
//                                             disabled={isSubmitting}
//                                         />
//                                         {errors.count && <span className="error-text">{errors.count}</span>}
//                                     </div>
//                                 </div>

//                                 {/* Description */}
//                                 <div className="form-group">
//                                     <label>Description *</label>
//                                     <textarea
//                                         name="desc"
//                                         value={formData.desc}
//                                         onChange={handleChange}
//                                         placeholder="Describe this gallery item..."
//                                         rows="4"
//                                         className={errors.desc ? "error" : ""}
//                                         disabled={isSubmitting}
//                                     ></textarea>
//                                     {errors.desc && <span className="error-text">{errors.desc}</span>}
//                                 </div>

//                                 {/* Main Image - File Upload Only */}
//                                 <div className="form-group">
//                                     <label>Main Image * {!editId && "(Required for new items)"}</label>
//                                     <div className="image-upload-options">
//                                         <div className="upload-option">
//                                             <label>Upload Image File:</label>
//                                             <input
//                                                 type="file"
//                                                 accept="image/*"
//                                                 onChange={handleImageFileChange}
//                                                 disabled={isSubmitting}
//                                             />
//                                             {formData.image_file && (
//                                                 <div className="file-info">
//                                                     <span>Selected: {formData.image_file.name}</span>
//                                                     <button 
//                                                         type="button" 
//                                                         onClick={() => {
//                                                             setFormData(prev => ({ ...prev, image_file: null }));
//                                                             setImagePreview("");
//                                                         }}
//                                                         disabled={isSubmitting}
//                                                     >
//                                                         Remove
//                                                     </button>
//                                                 </div>
//                                             )}
//                                             {editId && !formData.image_file && imagePreview && (
//                                                 <div className="file-info">
//                                                     <span>Current image will be kept</span>
//                                                     <button 
//                                                         type="button" 
//                                                         onClick={() => {
//                                                             setImagePreview("");
//                                                         }}
//                                                         disabled={isSubmitting}
//                                                     >
//                                                         Remove Preview
//                                                     </button>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                     {errors.image && <span className="error-text">{errors.image}</span>}
//                                 </div>

//                                 {/* Multiple Photo Uploads (only for new items) */}
//                                 {!editId && (
//                                     <div className="form-group">
//                                         <label>Initial Photos (Optional)</label>
//                                         <div className="photo-upload-section">
//                                             <input
//                                                 type="file"
//                                                 accept="image/*"
//                                                 multiple
//                                                 onChange={handlePhotosFilesChange}
//                                                 disabled={isSubmitting}
//                                             />
//                                             <small className="help-text">
//                                                 You can select multiple photos to add initially (JPG, PNG, WebP, max 5MB each)
//                                             </small>
                                            
//                                             {/* Photo previews */}
//                                             {photoPreviews.length > 0 && (
//                                                 <div className="photo-previews">
//                                                     <h4>Selected Photos ({photoPreviews.length})</h4>
//                                                     <div className="preview-grid">
//                                                         {photoPreviews.map((preview, index) => (
//                                                             <div key={index} className="preview-item">
//                                                                 <img src={preview} alt={`Preview ${index + 1}`} />
//                                                                 <button
//                                                                     type="button"
//                                                                     className="btn-remove-preview"
//                                                                     onClick={() => removePhoto(index)}
//                                                                     disabled={isSubmitting}
//                                                                 >
//                                                                     ×
//                                                                 </button>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Image Preview */}
//                                 {(imagePreview || (editId && formData.image)) && (
//                                     <div className="form-group">
//                                         <label>Main Image Preview</label>
//                                         <div className="image-preview">
//                                             <img
//                                                 src={imagePreview || formData.image}
//                                                 alt="Preview"
//                                                 onError={(e) => {
//                                                     e.target.onerror = null;
//                                                     e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Ctext x='50' y='50' font-family='Arial' font-size='10' text-anchor='middle' dy='.3em' fill='%23999'%3EImage not available%3C/text%3E%3C/svg%3E";
//                                                 }}
//                                             />
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className="modal-footer">
//                             <button className="btn-cancel" onClick={closeModal} disabled={isSubmitting}>
//                                 Cancel
//                             </button>
//                             <button className="btn-submit" onClick={handleSubmit} disabled={isSubmitting}>
//                                 {isSubmitting ? 'Saving...' : (editId ? "Update Gallery Item" : "Add Gallery Item")}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Add Photos Modal */}
//             {showAddPhotosModal && selectedGalleryForPhotos && (
//                 <div className="modal-overlay">
//                     <div className="modal-container">
//                         <div className="modal-header">
//                             <h3>Add Photos to: {selectedGalleryForPhotos.title}</h3>
//                             <button className="close-btn" onClick={closeAddPhotosModal} disabled={isUploadingPhotos}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="modal-form">
//                                 <div className="form-group">
//                                     <label>Select Photos to Upload</label>
//                                     <div className="photo-upload-section">
//                                         <input
//                                             type="file"
//                                             accept="image/*"
//                                             multiple
//                                             onChange={handleAddPhotosFileChange}
//                                             disabled={isUploadingPhotos}
//                                         />
//                                         <small className="help-text">
//                                             Select multiple photos (JPG, PNG, WebP, max 5MB each)
//                                         </small>
                                        
//                                         {/* Photo previews */}
//                                         {addPhotosData.photoPreviews.length > 0 && (
//                                             <div className="photo-previews">
//                                                 <h4>Selected Photos ({addPhotosData.photoPreviews.length})</h4>
//                                                 <div className="preview-grid">
//                                                     {addPhotosData.photoPreviews.map((preview, index) => (
//                                                         <div key={index} className="preview-item">
//                                                             <img src={preview} alt={`Preview ${index + 1}`} />
//                                                             <button
//                                                                 type="button"
//                                                                 className="btn-remove-preview"
//                                                                 onClick={() => removeAddPhoto(index)}
//                                                                 disabled={isUploadingPhotos}
//                                                             >
//                                                                 ×
//                                                             </button>
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="modal-footer">
//                             <button className="btn-cancel" onClick={closeAddPhotosModal} disabled={isUploadingPhotos}>
//                                 Cancel
//                             </button>
//                             <button 
//                                 className="btn-submit" 
//                                 onClick={uploadAdditionalPhotos} 
//                                 disabled={isUploadingPhotos || addPhotosData.photos_files.length === 0}
//                             >
//                                 {isUploadingPhotos ? 'Uploading...' : `Upload ${addPhotosData.photos_files.length} Photos`}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* View Gallery Details Modal */}
//             {showViewModal && selectedItem && (
//                 <div className="modal-overlay">
//                     <div className="modal-container view-modal">
//                         <div className="modal-header">
//                             <h3>Gallery Item Details</h3>
//                             <button className="close-btn" onClick={closeViewModal}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="gallery-details">
//                                 {/* Main Image */}
//                                 <div className="detail-image">
//                                     <img
//                                         src={selectedItem.image}
//                                         alt={selectedItem.title || 'Gallery Image'}
//                                         onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Ctext x='50' y='50' font-family='Arial' font-size='10' text-anchor='middle' dy='.3em' fill='%23999'%3EImage not available%3C/text%3E%3C/svg%3E";
//                                         }}
//                                     />
//                                 </div>

//                                 <div className="detail-section">
//                                     <h4>Basic Information</h4>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Type:</span>
//                                         <span className={`type-badge type-${selectedItem.type || 'photo'}`}>
//                                             {selectedItem.type === "photo" ? "📷 Photo Gallery" :
//                                                 selectedItem.type === "video" ? "🎥 Video Gallery" : "📰 Press Coverage"}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Category:</span>
//                                         <span className="detail-value">{selectedItem.category || "Uncategorized"}</span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Title:</span>
//                                         <span className="detail-value">{selectedItem.title || "Untitled"}</span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Main Item Count:</span>
//                                         <span className="detail-value">{selectedItem.count || 0}</span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Additional Photos:</span>
//                                         <span className="detail-value">{selectedItemPhotos.length}</span>
//                                     </div>
//                                 </div>

//                                 <div className="detail-section">
//                                     <h4>Description</h4>
//                                     <div className="detail-description">
//                                         {selectedItem.desc || "No description available"}
//                                     </div>
//                                 </div>

//                                 {selectedItemPhotos.length > 0 && (
//                                     <div className="detail-section">
//                                         <h4>Additional Photos ({selectedItemPhotos.length})</h4>
//                                         <div className="photo-grid">
//                                             {selectedItemPhotos.map((photo, index) => (
//                                                 <div key={photo.id} className="photo-thumbnail">
//                                                     <img
//                                                         src={photo.photo}
//                                                         alt={`Photo ${index + 1}`}
//                                                         onError={(e) => {
//                                                             e.target.onerror = null;
//                                                             e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f0f0f0'/%3E%3Ctext x='50' y='50' font-family='Arial' font-size='10' text-anchor='middle' dy='.3em' fill='%23999'%3EImage not available%3C/text%3E%3C/svg%3E";
//                                                         }}
//                                                     />
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className="modal-footer">
//                             <button className="btn-close" onClick={closeViewModal}>
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }
import { useState, useEffect, useCallback, useRef } from "react";
import "./Gallery.css"; // You'll need to create this or reuse Events.css

export default function Gallery() {
    const [galleries, setGalleries] = useState([]);
    const [editId, setEditId] = useState(null);
    const [filter, setFilter] = useState("All Categories");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedGallery, setSelectedGallery] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [mainImageFile, setMainImageFile] = useState(null);
    const [mainImagePreview, setMainImagePreview] = useState(null);
    const [photoFiles, setPhotoFiles] = useState([]);
    const [photoPreviews, setPhotoPreviews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    // Photo pagination in view modal
    const [currentPhotoPage, setCurrentPhotoPage] = useState(1);
    const [totalPhotoPages, setTotalPhotoPages] = useState(1);
    const [viewPhotos, setViewPhotos] = useState([]);
    const PHOTOS_PER_PAGE = 6;

    const mainImageInputRef = useRef(null);
    const photosInputRef = useRef(null);

    // ── Form fields ──
    const defaultForm = () => ({
        title: "",
        category: "Events",
        desc: "",
        type: "photo",
        count: "0"
    });

    const [formData, setFormData] = useState(defaultForm());
    const [errors, setErrors] = useState({});

    const categories = ["Events", "Activities", "Campaigns", "Community", "Awards", "Other"];
    const API_URL = process.env.REACT_APP_API_URL;

    // ─────────────────────────────────────────────────────
    // SAFE JSON PARSER
    // ─────────────────────────────────────────────────────
    const safeJson = async (res) => {
        const text = await res.text();
        try {
            return JSON.parse(text);
        } catch (err) {
            console.error("═══ RAW PHP RESPONSE (not JSON) ═══\n", text);
            throw new Error(`Server returned HTTP ${res.status} — see console for details`);
        }
    };

    // ─────────────────────────────────────────────────────
    // FETCH ALL GALLERIES
    // ─────────────────────────────────────────────────────
    const fetchGalleries = useCallback(async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}Gallery.php`);
            const data = await safeJson(res);

            if (data.status === "success" && Array.isArray(data.data)) {
                setGalleries(data.data);
            } else {
                console.error("Failed to fetch galleries:", data.message);
                setGalleries([]);
            }
        } catch (err) {
            console.error("Error fetching galleries:", err);
            setGalleries([]);
        } finally {
            setLoading(false);
        }
    }, [API_URL]);

    useEffect(() => {
        fetchGalleries();
    }, [fetchGalleries]);

    // ─────────────────────────────────────────────────────
    // FETCH SINGLE GALLERY WITH PAGINATED PHOTOS
    // ─────────────────────────────────────────────────────
    const fetchGalleryPhotos = async (galleryId, page = 1) => {
        try {
            const res = await fetch(
                `${API_URL}Gallery.php?id=${galleryId}&page=${page}&limit=${PHOTOS_PER_PAGE}`
            );
            const data = await safeJson(res);

            if (data.status === "success") {
                setViewPhotos(data.data.photos || []);
                if (data.pagination) {
                    setCurrentPhotoPage(data.pagination.page);
                    setTotalPhotoPages(data.pagination.total_pages);
                }
            }
        } catch (err) {
            console.error("Error fetching gallery photos:", err);
        }
    };

    // ─────────────────────────────────────────────────────
    // IMAGE HANDLING - Main Image
    // ─────────────────────────────────────────────────────
    const handleMainImageChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const validTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
        if (!validTypes.includes(file.type)) {
            alert("Only JPG, PNG, and WebP images are allowed");
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            alert("Image must be under 5MB");
            return;
        }

        setMainImageFile(file);

        const reader = new FileReader();
        reader.onloadend = () => setMainImagePreview(reader.result);
        reader.onerror = () => alert("Failed to read image file");
        reader.readAsDataURL(file);
    };

    const removeMainImage = () => {
        setMainImageFile(null);
        setMainImagePreview(null);
        if (mainImageInputRef.current) {
            mainImageInputRef.current.value = "";
        }
    };

    // ─────────────────────────────────────────────────────
    // MULTIPLE PHOTOS HANDLING
    // ─────────────────────────────────────────────────────
    const handlePhotosChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;

        const validTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
        const validFiles = files.filter(file => {
            if (!validTypes.includes(file.type)) {
                alert(`${file.name}: Only JPG, PNG, and WebP images are allowed`);
                return false;
            }
            if (file.size > 5 * 1024 * 1024) {
                alert(`${file.name}: Image must be under 5MB`);
                return false;
            }
            return true;
        });

        setPhotoFiles(validFiles);

        // Generate previews
        const previews = [];
        validFiles.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                previews.push(reader.result);
                if (previews.length === validFiles.length) {
                    setPhotoPreviews([...previews]);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const removePhoto = (index) => {
        setPhotoFiles(prev => prev.filter((_, i) => i !== index));
        setPhotoPreviews(prev => prev.filter((_, i) => i !== index));
    };

    const clearAllPhotos = () => {
        setPhotoFiles([]);
        setPhotoPreviews([]);
        if (photosInputRef.current) {
            photosInputRef.current.value = "";
        }
    };

    // ─────────────────────────────────────────────────────
    // VALIDATION
    // ─────────────────────────────────────────────────────
    const validateForm = () => {
        const newErrors = {};

        if (!formData.title.trim()) {
            newErrors.title = "Gallery title is required";
        } else if (formData.title.length < 3) {
            newErrors.title = "Title must be at least 3 characters";
        }

        if (!formData.desc.trim()) {
            newErrors.desc = "Description is required";
        }

        if (!editId && !mainImageFile) {
            newErrors.image = "Main image is required for new gallery";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    // ─────────────────────────────────────────────────────
    // MODAL HELPERS
    // ─────────────────────────────────────────────────────
    const openCreateModal = () => {
        setFormData(defaultForm());
        setEditId(null);
        setMainImageFile(null);
        setMainImagePreview(null);
        setPhotoFiles([]);
        setPhotoPreviews([]);
        setErrors({});
        setShowCreateModal(true);
    };

    const openEditModal = (gallery) => {
        setFormData({
            title: gallery.title || "",
            category: gallery.category || "Events",
            desc: gallery.desc || "",
            type: gallery.type || "photo",
            count: gallery.count?.toString() || "0"
        });
        setEditId(gallery.id);
        setMainImageFile(null);
        setMainImagePreview(gallery.image || null);
        setPhotoFiles([]);
        setPhotoPreviews([]);
        setErrors({});
        setShowCreateModal(true);
    };

    const closeModal = () => {
        setShowCreateModal(false);
        setEditId(null);
        setFormData(defaultForm());
        setMainImageFile(null);
        setMainImagePreview(null);
        setPhotoFiles([]);
        setPhotoPreviews([]);
        setErrors({});
    };

    // ─────────────────────────────────────────────────────
    // SUBMIT - CREATE & UPDATE
    // ─────────────────────────────────────────────────────
    // const handleSubmit = async () => {
    //     if (!validateForm()) {
    //         alert("Please fix validation errors");
    //         return;
    //     }

    //     setIsProcessing(true);

    //     const fd = new FormData();
    //     fd.append("title", formData.title);
    //     fd.append("category", formData.category);
    //     fd.append("desc", formData.desc);
    //     fd.append("type", formData.type);
    //     fd.append("count", photoFiles.length || formData.count);

    //     if (mainImageFile) {
    //         fd.append("image", mainImageFile, mainImageFile.name);
    //     }

    //     // Append multiple photos
    //     photoFiles.forEach((file, index) => {
    //         fd.append(`photos[]`, file, file.name);
    //     });

    //     try {
    //         if (editId) {
    //             fd.append("id", String(editId));
    //             fd.append("_method", "PUT");
    //         }

    //         const res = await fetch(`${API_URL}Gallery.php`, {
    //             method: "POST",
    //             body: fd
    //         });

    //         const result = await safeJson(res);

    //         if (result.status === "success") {
    //             alert(editId ? "Gallery Updated Successfully" : "Gallery Created Successfully");
    //             closeModal();
    //             fetchGalleries();
    //         } else {
    //             alert(result.message || "Operation failed");
    //         }
    //     } catch (err) {
    //         console.error("Submit error:", err);
    //         alert("Server error. Please try again.");
    //     } finally {
    //         setIsProcessing(false);
    //     }
    // };
const handleSubmit = async () => {
    if (!validateForm()) {
        alert("Please fix validation errors");
        return;
    }

    setIsProcessing(true);

    const fd = new FormData();
    fd.append("title", formData.title);
    fd.append("category", formData.category);
    fd.append("desc", formData.desc);
    fd.append("type", formData.type);
    fd.append("count", photoFiles.length || formData.count);

    if (mainImageFile) {
        fd.append("image", mainImageFile);
    }

    photoFiles.forEach(file => {
        fd.append("photos[]", file);
    });

    if (editId) {
        fd.append("id", String(editId));
        fd.append("_method", "PUT"); // ✅ reliable
    }

    try {
        const res = await fetch(`${API_URL}Gallery.php`, {
            method: "POST",
            body: fd
        });

        const result = await safeJson(res);

        if (result.status === "success") {
            alert(editId ? "Gallery Updated Successfully" : "Gallery Created Successfully");
            closeModal();
            fetchGalleries();
        } else {
            alert(result.message || "Operation failed");
        }

    } catch (err) {
        console.error("Submit error:", err);
        alert("Server error. Please try again.");
    } finally {
        setIsProcessing(false);
    }
};
    // ─────────────────────────────────────────────────────
    // DELETE
    // ─────────────────────────────────────────────────────
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this gallery? This will also delete all photos.")) {
            return;
        }

        setIsProcessing(true);
        try {
            const res = await fetch(`${API_URL}Gallery.php`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: Number(id) })
            });

            const result = await safeJson(res);

            if (result.status === "success") {
                alert("Gallery deleted successfully!");
                fetchGalleries();
            } else {
                alert(result.message || "Failed to delete gallery");
            }
        } catch (err) {
            console.error("Delete error:", err);
            alert("Failed to delete gallery. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    // ─────────────────────────────────────────────────────
    // VIEW MODAL WITH PHOTO PAGINATION
    // ─────────────────────────────────────────────────────
    const handleViewDetails = async (gallery) => {
        setSelectedGallery(gallery);
        setShowViewModal(true);
        setCurrentPhotoPage(1);
        await fetchGalleryPhotos(gallery.id, 1);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedGallery(null);
        setViewPhotos([]);
        setCurrentPhotoPage(1);
        setTotalPhotoPages(1);
    };

    const goToPhotoPage = async (page) => {
        if (page < 1 || page > totalPhotoPages || !selectedGallery) return;
        await fetchGalleryPhotos(selectedGallery.id, page);
    };

    // ─────────────────────────────────────────────────────
    // CLIENT-SIDE FILTER
    // ─────────────────────────────────────────────────────
    const filteredGalleries = galleries.filter((gallery) => {
        const matchesCategory = filter === "All Categories" || gallery.category === filter;
        const matchesSearch =
            searchTerm === "" ||
            (gallery.title || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
            (gallery.desc || "").toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    // ═════════════════════════════════════════════════════
    // RENDER
    // ═════════════════════════════════════════════════════
    return (
        <div className="events-admin"> {/* Reusing events-admin class */}
            {/* ── Header ── */}
            <div className="events-header">
                <div className="header-top">
                    <h2>
                        <span>🖼️</span> Gallery Management
                    </h2>
                    <button className="btn-create" onClick={openCreateModal} disabled={isProcessing}>
                        <span>+</span> Create New Gallery
                    </button>
                </div>
                <p className="subtitle">Manage photo galleries and collections</p>

                <div className="filters-section">
                    <div className="search-bar">
                        <input
                            type="text"
                            placeholder="Search galleries by title or description..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            disabled={isProcessing}
                        />
                    </div>
                    <div className="filters">
                        <div className="filter-group">
                            <label htmlFor="category-filter">Category:</label>
                            <select
                                id="category-filter"
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                className="filter-select"
                                disabled={isProcessing}
                            >
                                <option value="All Categories">All Categories</option>
                                {categories.map((cat) => (
                                    <option key={cat} value={cat}>
                                        {cat}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="loading-state">
                    <div className="loading-spinner"></div>
                    <p>Loading galleries...</p>
                </div>
            ) : (
                <>
                    <div className="events-stats">
                        <div className="stat-card">
                            <div className="stat-icon">🖼️</div>
                            <div className="stat-content">
                                <h3>{filteredGalleries.length}</h3>
                                <p>Total Galleries</p>
                            </div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-icon">📸</div>
                            <div className="stat-content">
                                <h3>{galleries.reduce((sum, g) => sum + (parseInt(g.count) || 0), 0)}</h3>
                                <p>Total Photos</p>
                            </div>
                        </div>
                    </div>

                    <div className="events-list-container">
                        <div className="list-header">
                            <h3>All Galleries ({filteredGalleries.length})</h3>
                        </div>

                        {filteredGalleries.length === 0 ? (
                            <div className="empty-state">
                                <div className="empty-icon">🖼️</div>
                                <p>No galleries found</p>
                                <p className="empty-subtext">
                                    {searchTerm || filter !== "All Categories"
                                        ? "Try a different search or filter"
                                        : "Create your first gallery to get started"}
                                </p>
                                <button className="btn-create-empty" onClick={openCreateModal} disabled={isProcessing}>
                                    Create New Gallery
                                </button>
                            </div>
                        ) : (
                            <div className="events-table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Gallery</th>
                                            <th>Category</th>
                                            <th>Photos</th>
                                            <th>Type</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredGalleries.map((gallery) => (
                                            <tr key={gallery.id}>
                                                <td className="event-info">
                                                    <div className="event-title">{gallery.title || "Untitled Gallery"}</div>
                                                    {gallery.image && (
                                                        <img
                                                            src={gallery.image}
                                                            alt={gallery.title}
                                                            style={{
                                                                width: "60px",
                                                                height: "60px",
                                                                objectFit: "cover",
                                                                borderRadius: "4px",
                                                                marginTop: "8px"
                                                            }}
                                                            onError={(e) => {
                                                                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Crect fill='%23ddd' width='60' height='60'/%3E%3C/svg%3E";
                                                            }}
                                                        />
                                                    )}
                                                </td>
                                                <td className="event-category">
                                                    <span className="category-badge">{gallery.category || "Uncategorized"}</span>
                                                </td>
                                                <td className="event-registered">
                                                    <div className="registration-count">{parseInt(gallery.count) || 0} photos</div>
                                                </td>
                                                <td className="event-status">
                                                    <span className="status-badge">{gallery.type || "photo"}</span>
                                                </td>
                                                <td className="event-actions">
                                                    <div className="action-buttons">
                                                        <button
                                                            className="btn-view"
                                                            onClick={() => handleViewDetails(gallery)}
                                                            title="View Gallery"
                                                            disabled={isProcessing}
                                                        >
                                                            👁️
                                                        </button>
                                                        <button
                                                            className="btn-edit"
                                                            onClick={() => openEditModal(gallery)}
                                                            title="Edit Gallery"
                                                            disabled={isProcessing}
                                                        >
                                                            ✏️
                                                        </button>
                                                        <button
                                                            className="btn-delete"
                                                            onClick={() => handleDelete(gallery.id)}
                                                            title="Delete Gallery"
                                                            disabled={isProcessing}
                                                        >
                                                            🗑️
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* CREATE/EDIT MODAL */}
            {showCreateModal && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && closeModal()}>
                    <div className="modal-container">
                        <div className="modal-header">
                            <h3>{editId ? "Edit Gallery" : "Create New Gallery"}</h3>
                            <button className="close-btn" onClick={closeModal} disabled={isProcessing}>
                                ×
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="modal-form">
                                {/* Main Image Upload */}
                                <div className="form-group">
                                    <label>Main Gallery Image *</label>
                                    <div className="image-upload-container">
                                        <input
                                            ref={mainImageInputRef}
                                            type="file"
                                            accept="image/jpeg,image/png,image/webp,image/jpg"
                                            onChange={handleMainImageChange}
                                            style={{ display: "none" }}
                                            disabled={isProcessing}
                                        />

                                        {mainImagePreview ? (
                                            <div className="image-preview">
                                                <img
                                                    src={mainImagePreview}
                                                    alt="Main Preview"
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                        maxHeight: "200px",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                                <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                                                    <button
                                                        type="button"
                                                        className="remove-image-btn"
                                                        onClick={removeMainImage}
                                                        disabled={isProcessing}
                                                    >
                                                        Remove Image
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="remove-image-btn"
                                                        onClick={() => mainImageInputRef.current?.click()}
                                                        disabled={isProcessing}
                                                    >
                                                        Change Image
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                className="image-upload-area"
                                                onClick={() => !isProcessing && mainImageInputRef.current?.click()}
                                                style={{ cursor: isProcessing ? "not-allowed" : "pointer" }}
                                            >
                                                <div className="upload-icon">📷</div>
                                                <div className="upload-text">Click to upload main image</div>
                                                <div className="upload-subtext">JPG, PNG, WebP (max 5MB)</div>
                                            </div>
                                        )}
                                    </div>
                                    {errors.image && <span className="error-text">{errors.image}</span>}
                                </div>

                                {/* Title */}
                                <div className="form-group">
                                    <label>Gallery Title *</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        placeholder="Enter gallery title"
                                        className={errors.title ? "error" : ""}
                                        disabled={isProcessing}
                                    />
                                    {errors.title && <span className="error-text">{errors.title}</span>}
                                </div>

                                {/* Category & Type */}
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Category *</label>
                                        <select name="category" value={formData.category} onChange={handleChange} disabled={isProcessing}>
                                            {categories.map((cat) => (
                                                <option key={cat} value={cat}>
                                                    {cat}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Type</label>
                                        <select name="type" value={formData.type} onChange={handleChange} disabled={isProcessing}>
                                            <option value="photo">Photo</option>
                                            <option value="video">Video</option>
                                            <option value="mixed">Mixed</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Description */}
                                <div className="form-group">
                                    <label>Description *</label>
                                    <textarea
                                        name="desc"
                                        value={formData.desc}
                                        onChange={handleChange}
                                        placeholder="Describe the gallery..."
                                        rows="4"
                                        className={errors.desc ? "error" : ""}
                                        disabled={isProcessing}
                                    />
                                    {errors.desc && <span className="error-text">{errors.desc}</span>}
                                </div>

                                {/* Multiple Photos Upload */}
                                <div className="form-group">
                                    <label>Gallery Photos (Multiple)</label>
                                    <div className="image-upload-container">
                                        <input
                                            ref={photosInputRef}
                                            type="file"
                                            accept="image/jpeg,image/png,image/webp,image/jpg"
                                            onChange={handlePhotosChange}
                                            multiple
                                            style={{ display: "none" }}
                                            disabled={isProcessing}
                                        />

                                        <div
                                            className="image-upload-area"
                                            onClick={() => !isProcessing && photosInputRef.current?.click()}
                                            style={{ cursor: isProcessing ? "not-allowed" : "pointer", marginBottom: "10px" }}
                                        >
                                            <div className="upload-icon">📸</div>
                                            <div className="upload-text">Click to upload multiple photos</div>
                                            <div className="upload-subtext">JPG, PNG, WebP (max 5MB each)</div>
                                        </div>

                                        {photoPreviews.length > 0 && (
                                            <div>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                                    <span>{photoPreviews.length} photo(s) selected</span>
                                                    <button
                                                        type="button"
                                                        className="remove-image-btn"
                                                        onClick={clearAllPhotos}
                                                        disabled={isProcessing}
                                                    >
                                                        Clear All
                                                    </button>
                                                </div>
                                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))", gap: "10px" }}>
                                                    {photoPreviews.map((preview, index) => (
                                                        <div key={index} style={{ position: "relative" }}>
                                                            <img
                                                                src={preview}
                                                                alt={`Preview ${index + 1}`}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "4px"
                                                                }}
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={() => removePhoto(index)}
                                                                disabled={isProcessing}
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "5px",
                                                                    right: "5px",
                                                                    background: "rgba(255,0,0,0.8)",
                                                                    color: "white",
                                                                    border: "none",
                                                                    borderRadius: "50%",
                                                                    width: "24px",
                                                                    height: "24px",
                                                                    cursor: "pointer",
                                                                    fontSize: "16px",
                                                                    lineHeight: "1"
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn-cancel" onClick={closeModal} disabled={isProcessing}>
                                Cancel
                            </button>
                            <button className="btn-submit" onClick={handleSubmit} disabled={isProcessing}>
                                {isProcessing ? "Processing..." : editId ? "Update Gallery" : "Create Gallery"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* VIEW MODAL WITH PHOTO PAGINATION */}
            {showViewModal && selectedGallery && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && closeViewModal()}>
                    <div className="modal-container view-modal" style={{ maxWidth: "900px" }}>
                        <div className="modal-header">
                            <h3>{selectedGallery.title}</h3>
                            <button className="close-btn" onClick={closeViewModal}>
                                ×
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="event-details">
                                {/* Main Image */}
                                {selectedGallery.image && (
                                    <div className="detail-section image-section">
                                        <h4>Main Image</h4>
                                        <img
                                            src={selectedGallery.image}
                                            alt={selectedGallery.title}
                                            style={{
                                                width: "100%",
                                                maxHeight: "400px",
                                                objectFit: "cover",
                                                borderRadius: "8px"
                                            }}
                                            onError={(e) => {
                                                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23f0f0f0' width='400' height='300'/%3E%3Ctext fill='%23999' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EImage not available%3C/text%3E%3C/svg%3E";
                                            }}
                                        />
                                    </div>
                                )}

                                {/* Gallery Info */}
                                <div className="detail-section">
                                    <h4>Gallery Information</h4>
                                    <div className="detail-row">
                                        <span className="detail-label">Category:</span>
                                        <span className="detail-value">{selectedGallery.category}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Type:</span>
                                        <span className="detail-value">{selectedGallery.type}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Description:</span>
                                        <span className="detail-value">{selectedGallery.desc || "No description"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Total Photos:</span>
                                        <span className="detail-value">{parseInt(selectedGallery.count) || 0}</span>
                                    </div>
                                </div>

                                {/* Photos Grid with Pagination */}
                                <div className="detail-section">
                                    <h4>Gallery Photos</h4>
                                    {viewPhotos.length > 0 ? (
                                        <>
                                            <div style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                                                gap: "15px",
                                                marginTop: "15px"
                                            }}>
                                                {viewPhotos.map((photo, index) => (
                                                    <div key={photo.id} style={{ position: "relative" }}>
                                                        <img
                                                            src={photo.photo}
                                                            alt={`Gallery photo ${index + 1}`}
                                                            style={{
                                                                width: "100%",
                                                                height: "200px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => window.open(photo.photo, '_blank')}
                                                            onError={(e) => {
                                                                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect fill='%23ddd' width='200' height='200'/%3E%3C/svg%3E";
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Photo Pagination */}
                                            {totalPhotoPages > 1 && (
                                                <div className="pagination" style={{ marginTop: "20px" }}>
                                                    <button
                                                        className="pagination-btn prev"
                                                        onClick={() => goToPhotoPage(currentPhotoPage - 1)}
                                                        disabled={currentPhotoPage === 1}
                                                    >
                                                        ← Previous
                                                    </button>

                                                    <div className="pagination-numbers">
                                                        {Array.from({ length: Math.min(totalPhotoPages, 5) }, (_, i) => {
                                                            let pageNum;
                                                            if (totalPhotoPages <= 5) {
                                                                pageNum = i + 1;
                                                            } else if (currentPhotoPage <= 3) {
                                                                pageNum = i + 1;
                                                            } else if (currentPhotoPage >= totalPhotoPages - 2) {
                                                                pageNum = totalPhotoPages - 4 + i;
                                                            } else {
                                                                pageNum = currentPhotoPage - 2 + i;
                                                            }
                                                            return (
                                                                <button
                                                                    key={pageNum}
                                                                    className={`pagination-number ${
                                                                        currentPhotoPage === pageNum ? "active" : ""
                                                                    }`}
                                                                    onClick={() => goToPhotoPage(pageNum)}
                                                                >
                                                                    {pageNum}
                                                                </button>
                                                            );
                                                        })}
                                                    </div>

                                                    <button
                                                        className="pagination-btn next"
                                                        onClick={() => goToPhotoPage(currentPhotoPage + 1)}
                                                        disabled={currentPhotoPage === totalPhotoPages}
                                                    >
                                                        Next →
                                                    </button>

                                                    <div className="page-info">
                                                        Page {currentPhotoPage} of {totalPhotoPages}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <p style={{ textAlign: "center", color: "#999", marginTop: "20px" }}>
                                            No photos in this gallery yet
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn-close" onClick={closeViewModal}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}